import React, { memo, useCallback, useState, KeyboardEvent } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { IconClose02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  /** type */
  type: 'left' | 'right' | 'rightCenter';
  /** text */
  text?: string;
  /** className */
  className?: string;
  /** onClose */
  onClose?: () => void;
}

const TooltipItem = ({ type = 'left', text, className, onClose }: IProps) => {
  const cName = classNameBind(['tooltip-item', className || '']);
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if ((e.target as HTMLElement).closest('.btn-close')) {
        e.preventDefault();
        e.stopPropagation();
        handleClose();
      }
    },
    [handleClose]
  );

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClose();
      }
    },
    [handleClose]
  );

  const getTooltipRender = useCallback(
    () => (
      <>
        <Text>{text}</Text>
        <div
          className="btn-close"
          role="button"
          tabIndex={0}
          aria-label="툴팁 닫기"
          onClick={handleClose}
          onKeyDown={handleKeyDown}
        >
          <IconClose02 />
        </div>
      </>
    ),
    [handleClose, handleKeyDown, text]
  );

  if (!isVisible) {
    return null;
  }

  return (
    <S.TooltipItem className={cName} type={type} onClick={handleClick}>
      {getTooltipRender()}
    </S.TooltipItem>
  );
};

export default memo(TooltipItem);
